var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4621 795.442C96.9554 798.487 103.026 800 109.091 800C115.789 800 122.478 798.15 128.364 794.473L710.182 430.839C720.815 424.194 727.273 412.541 727.273 400.002C727.273 387.464 720.815 375.811 710.182 369.166L128.364 5.52729C117.152 -1.48119 103.023 -1.84968 91.4621 4.5576C79.9009 10.9673 72.7275 23.1443 72.7275 36.3637V763.636C72.7275 776.856 79.9009 789.033 91.4621 795.442Z",
    fill: "#ef4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a07979b347f3e91e35440ca7f4247582.svg";
export { ForwardRef as ReactComponent };